import React from 'react'
import { AutoSizer, List } from 'react-virtualized'
import styled from 'styled-components'
import { BookPage } from './book-page'
import { IBook } from '../../types'
import { ConrolPanel } from './control-panel'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'


export const BookViewer: React.FC<{ book: IBook }> = ({ book }) => {
  return (
    <Wrapper>
      <TransformWrapper
        initialScale={1}
        centerOnInit={true}
        centerZoomedOut={true}
        wheel={{ disabled: true }}
        pinch={{ disabled: true }}
        doubleClick={{ disabled: true }}
        panning={{ disabled: true }}
      >
        {() => (
          <>
            <AutoSizer>
              {
                ({ width, height }) => (
                  <TransformComponent>
                    <List
                      width={width}
                      height={height}
                      rowHeight={height}
                      rowRenderer={({ index, key, style }) => (
                        <BookPage hasPermission={book.can_view_unblured_book}
                                  bookId={book.uuid} key={key}
                                  pageIndex={index}
                                  style={style}
                        />
                      )}
                      rowCount={book.page_count}
                      overscanRowCount={1}
                    />
                  </TransformComponent>
                )
              }
            </AutoSizer>
            <ConrolPanel/>
          </>
        )}
      </TransformWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
`
